import { useCallback } from "react";
import { sharedStateKeys } from "../../../constants/constant";

const useNonServicableZipcodes = ({
  brandDetails,
  formValues,
  setFranchiseLimit,
  setIsModalOpen,
  setIsServiceModalOpen,
  foundNearByLocations,
  formConfig,
  searchNearbyLocations,
  ContactUsApiCallHandler,
  getSessionAndCorrelationID,
  state,
}) => {
  const handleNonServicableZipcodes = useCallback(async () => {
    if (!brandDetails) return;

    const sessionAndCorrelation = getSessionAndCorrelationID();
    const correlationID = sessionAndCorrelation.correlationID;
    const addressResults =
      state[sharedStateKeys.S_STATE_ADDRESS_SUGGESTION_RES];
    const suggestedSelected =
      sessionStorage.getItem("selectedAddressFromDropdown") ?? "false";
    const enable50MileRadius = brandDetails.enable_50mile_area_OSflow;
    const nearByFranchiseLimit =
      brandDetails?.nearest_franchiselimit_OSflow as number;

    setFranchiseLimit(nearByFranchiseLimit || 50);

    if (addressResults?.length > 0 && suggestedSelected !== "true") {
      setIsModalOpen(true);
      return;
    }

    // Handle nearby locations based on 50-mile radius setting
    if (enable50MileRadius) {
      await searchNearbyLocations(formValues?.zipcode as string, brandDetails);
    } else if (brandDetails.lead_contactapi && !foundNearByLocations) {
      // Handle lead contact API logic
      await ContactUsApiCallHandler(formValues, formConfig, correlationID);
    } else if (!brandDetails.lead_contactapi && !foundNearByLocations) {
      // Handle non-servicable zip codes when lead contact API is disabled
      setIsModalOpen(false);
      setIsServiceModalOpen(true);
      return;
    }
  }, [formValues, foundNearByLocations, formConfig, searchNearbyLocations]);

  return { handleNonServicableZipcodes };
};

export default useNonServicableZipcodes;
